import React from "react";

export const AccountIdentity: React.FC<{
  email: string;
  detail?: string;
}> = ({ email, detail }) => (
  <>
    <span
      className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-observe-lightest text-[15px] font-semibold text-observe-white"
      aria-hidden
    >
      {email.charAt(0).toUpperCase()}
    </span>
    <span className="flex min-w-0 flex-1 flex-col">
      <span className="truncate text-[15px] text-observe-white">{email}</span>
      {detail && <span className="text-xs text-dark">{detail}</span>}
    </span>
  </>
);
